import {trans} from '@frontend/helpers'
import {useIsMobileScreen} from '@frontend/hooks/useIsMobileScreen'
import type {ItemsListRouteParams} from '@frontend/modules/public/ads/AdsModuleTypes'
import {mdiTuneVariant} from '@mdi/js'
import {useState} from 'react'
import {useParams} from 'react-router-dom'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {Modal} from 'swayok-react-mdb-ui-kit/components/Modal/Modal'
import {extractIdFromUrlSlug} from '../../../../../helpers/extractIdFromUrlSlug'
import {LocationSelector} from '../search/LocationSelector'
import {ItemsCategoryFiltersCard} from './ItemsCategoryFiltersCard'
import {ItemsCategoryQuickFiltersMobile} from './ItemsCategoryQuickFiltersMobile'

interface ItemsCategoryFiltersPanelMobileProps {
    services?: boolean
    className?: string
}

// Строка с выбором локации и кнопкой, открывающей панель фильтрации на мобильных телефонах.
export function ItemsCategoryFiltersPanelMobile(
    props: ItemsCategoryFiltersPanelMobileProps
) {
    const isMobile = useIsMobileScreen()
    const routeParams = useParams<ItemsListRouteParams>()

    const {
        services,
        className,
    } = props

    const categoryId: number | null = extractIdFromUrlSlug(routeParams.slugWithId)

    const [
        isFiltersModalVisible,
        setIsFiltersModalVisible,
    ] = useState<boolean>(false)

    if (
        !isMobile
        || !categoryId
    ) {
        return null
    }

    return (
        <div className={className}>
            <div className="d-flex flex-row align-items-center justify-content-between">
                <LocationSelector textMode />
                <Button
                    color="link"
                    className="link-dark with-icon-flex gap-2 p-0"
                    onClick={() => setIsFiltersModalVisible(true)}
                >
                    {trans().ads.list.filters.header}
                    <Icon path={mdiTuneVariant} />
                </Button>
            </div>
            <ItemsCategoryQuickFiltersMobile
                services={services}
                className="mt-3"
                onOpenAllFilters={() => setIsFiltersModalVisible(true)}
            />
            <Modal
                show={isFiltersModalVisible}
                className="bottom-drawer"
                closeOnEsc
                onClose={() => {
                    setIsFiltersModalVisible(false)
                }}
            >
                <ItemsCategoryFiltersCard
                    forModal
                    services={services}
                    onClose={() => setIsFiltersModalVisible(false)}
                />
            </Modal>
        </div>
    )
}
